// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Anek+Malayalam:wght@100;200;300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-container {
  background: #ffffff;
  border-radius: 4px;
  padding: 30px 60px;
  height: "100vh",
}

.quiz-container .active-question-no {
  font-size: 32px;
  font-weight: 500;
  color: #582630;
}

.quiz-container .total-question {
  font-size: 16px;
  font-weight: 500;
  color: #e0dee3;
}

.quiz-container h2 {
  font-size: 20px;
  font-weight: 500;
  margin: 0;
}

.quiz-container ul {
  margin-top: 20px;
  margin-left: -40px;
}

.quiz-container ul li {
  text-decoration: none;
  list-style: none;
  color: #2d264b;
  font-size: 16px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 16px;
  padding: 11px;
  margin-top: 15px;
  cursor: pointer;
}

.quiz-container ul .selected-answer {
  background: linear-gradient(90.04deg, #582630 0.03%, #ffc0cb 99.96%);
  font-weight: 500;
  color: #ffffff;
}

.quiz-container button {
  background: #582630;
  border-radius: 9px;
  font-size: 18px;
  color: #ffffff;
  padding: 10px 42px;
  outline: none;
  border: none;
  cursor: pointer;
  margin-top: 15px;
}

.quiz-container button:disabled {
  background: #e7e8e9;
  color: #9fa3a9;
  cursor: not-allowed;
}


.result h3 {
  font-size: 40px;
  letter-spacing: 1.4px;
  text-align: center;
}

.result p {
  font-size: 16px;
  font-weight: 500;
  text-align: center;
}

.result p span {
  color: #582630;
  font-size: 22px;
  text-align: center;
}

.timer{
color: #582630;
font-weight: bolder;
margin-left: 70%;
font-size: 20px;
}
.options{
  display: block;
  width: 90%
}
.previous-button{
  float: left;
}

.next-button{
  float: right;
}

.test-question-divstyle{ 
  overflow: auto;
  max-height: 25vh;
  font-size: 18px;
 }

 .test-option-divstyle{ 
  overflow: auto;
  max-height: 50vh
 }`, "",{"version":3,"sources":["webpack://./src/components/modules/learners/quizPage/Quiz.css"],"names":[],"mappings":"AAGA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oEAAoE;EACpE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;AACA,cAAc;AACd,mBAAmB;AACnB,gBAAgB;AAChB,eAAe;AACf;AACA;EACE,cAAc;EACd;AACF;AACA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;CAChB;;CAEA;EACC,cAAc;EACd;CACD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Anek+Malayalam:wght@100;200;300;400;500;600;700;800&display=swap');\n\n\n.quiz-container {\n  background: #ffffff;\n  border-radius: 4px;\n  padding: 30px 60px;\n  height: \"100vh\",\n}\n\n.quiz-container .active-question-no {\n  font-size: 32px;\n  font-weight: 500;\n  color: #582630;\n}\n\n.quiz-container .total-question {\n  font-size: 16px;\n  font-weight: 500;\n  color: #e0dee3;\n}\n\n.quiz-container h2 {\n  font-size: 20px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.quiz-container ul {\n  margin-top: 20px;\n  margin-left: -40px;\n}\n\n.quiz-container ul li {\n  text-decoration: none;\n  list-style: none;\n  color: #2d264b;\n  font-size: 16px;\n  background: #ffffff;\n  border: 1px solid #eaeaea;\n  border-radius: 16px;\n  padding: 11px;\n  margin-top: 15px;\n  cursor: pointer;\n}\n\n.quiz-container ul .selected-answer {\n  background: linear-gradient(90.04deg, #582630 0.03%, #ffc0cb 99.96%);\n  font-weight: 500;\n  color: #ffffff;\n}\n\n.quiz-container button {\n  background: #582630;\n  border-radius: 9px;\n  font-size: 18px;\n  color: #ffffff;\n  padding: 10px 42px;\n  outline: none;\n  border: none;\n  cursor: pointer;\n  margin-top: 15px;\n}\n\n.quiz-container button:disabled {\n  background: #e7e8e9;\n  color: #9fa3a9;\n  cursor: not-allowed;\n}\n\n\n.result h3 {\n  font-size: 40px;\n  letter-spacing: 1.4px;\n  text-align: center;\n}\n\n.result p {\n  font-size: 16px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.result p span {\n  color: #582630;\n  font-size: 22px;\n  text-align: center;\n}\n\n.timer{\ncolor: #582630;\nfont-weight: bolder;\nmargin-left: 70%;\nfont-size: 20px;\n}\n.options{\n  display: block;\n  width: 90%\n}\n.previous-button{\n  float: left;\n}\n\n.next-button{\n  float: right;\n}\n\n.test-question-divstyle{ \n  overflow: auto;\n  max-height: 25vh;\n  font-size: 18px;\n }\n\n .test-option-divstyle{ \n  overflow: auto;\n  max-height: 50vh\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
